import styled, { keyframes, css } from 'styled-components'

// paleta — deriva das variáveis do tema (funciona em light e dark).
// Sem color-mix (compatível com qualquer navegador): fundos suaves usam os
// tokens *-soft do tema, ou rgba translúcido onde não há token.
const TEAL = 'var(--teal)'
const TEAL_TEXT = 'var(--teal-text, var(--teal))'
const TEAL_LIGHT = 'var(--teal-light)'
const TEAL_SOFT = 'var(--teal-soft)'
const TEXT = 'var(--text, var(--text-muted))'
const TEXT2 = 'var(--text-2, var(--text-muted))'
const GRAY_BG = 'var(--bg)'
const SURF2 = 'var(--surface-2)'
const GRAY_LINE = 'var(--line)'
const GRAY_TEXT = 'var(--text-muted)'
const RED = 'var(--red, #dc2626)'
const RED_SOFT = 'var(--red-soft, rgba(207,58,58,0.16))'
const GREEN = 'var(--green)'
const GREEN_SOFT = 'var(--green-soft, rgba(29,139,90,0.16))'
const AMBER = 'var(--amber, #d97706)'
const AMBER_SOFT = 'rgba(217, 119, 6, 0.18)'
const BLUE = 'var(--blue, #3b82f6)'
const BLUE_SOFT = 'rgba(59, 130, 246, 0.18)'
const RING = 'rgba(21, 112, 137, 0.30)'

// breakpoints (mobile-first friendly)
const bp = {
    desktop: '1024px',
    tablet: '768px',
    mobile: '540px',
    small: '380px'
}

const expand = keyframes`
    from { opacity: 0; transform: translateY(-6px); max-height: 0; }
    to   { opacity: 1; transform: translateY(0);    max-height: 9999px; }
`

const shimmer = keyframes`
    0%   { background-position: -400px 0; }
    100% { background-position: 400px 0; }
`

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    background: ${GRAY_BG};
    color: ${TEXT};
    padding: 16px;
    display: flex;
    justify-content: center;

    @media (max-width: ${bp.tablet}) {
        padding: 12px;
    }
    @media (max-width: ${bp.mobile}) {
        padding: 8px;
    }
`

export const ContainerDivs = styled.div`
    width: 100%;
    max-width: 960px;
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${bp.mobile}) {
        gap: 10px;
    }
`

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 18px 20px;
    background: ${TEAL};
    color: #fff;
    border-radius: 14px;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.35);
    flex-wrap: wrap;

    @media (max-width: ${bp.mobile}) {
        padding: 14px 16px;
        border-radius: 12px;
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }
`

export const Title = styled.h1`
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    letter-spacing: 0.2px;

    @media (max-width: ${bp.mobile}) {
        font-size: 17px;
        text-align: center;
    }
    @media (max-width: ${bp.small}) {
        font-size: 16px;
    }
`

export const NewActivityButton = styled.button`
    background: var(--surface);
    color: ${TEAL_TEXT};
    border: 1px solid ${GRAY_LINE};
    padding: 10px 18px;
    border-radius: 10px;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    transition: transform .12s ease, box-shadow .12s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 40px;

    &:hover { transform: translateY(-1px); box-shadow: 0 4px 12px rgba(0,0,0,.22); }
    &:active { transform: translateY(0); }
    &:focus-visible { outline: 2px solid #fff; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) {
        width: 100%;
        padding: 12px 16px;
        font-size: 15px;
        min-height: 44px;
    }
`

export const Toolbar = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
    flex-wrap: wrap;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 10px 12px;

    @media (max-width: ${bp.mobile}) {
        padding: 8px 10px;
        gap: 6px;
    }
`

export const ToolbarActions = styled.div`
    display: flex;
    gap: 6px;
    align-items: center;
    flex-wrap: wrap;
`

export const SearchInput = styled.input`
    flex: 1;
    min-width: 200px;
    border: 1px solid ${GRAY_LINE};
    background: var(--surface);
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: ${TEXT};
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;

    &::placeholder { color: ${GRAY_TEXT}; }
    &:focus {
        border-color: ${TEAL_LIGHT};
        box-shadow: 0 0 0 3px ${RING};
    }

    @media (max-width: ${bp.mobile}) {
        min-width: 100%;
        padding: 11px 12px;
        font-size: 16px; /* evita zoom no iOS */
        min-height: 44px;
    }
`

export const ToggleAllButton = styled.button`
    background: ${TEAL_SOFT};
    color: ${TEAL_TEXT};
    border: 1px solid ${TEAL_LIGHT};
    padding: 8px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: filter .12s ease;
    min-height: 36px;

    &:hover { filter: brightness(1.12); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) {
        flex: 1;
        min-height: 40px;
        font-size: 13px;
    }
`

export const EmptyState = styled.div`
    background: var(--surface);
    border: 1px dashed ${GRAY_LINE};
    border-radius: 12px;
    padding: 32px;
    text-align: center;
    color: ${GRAY_TEXT};
    font-size: 14px;

    @media (max-width: ${bp.mobile}) {
        padding: 24px 16px;
    }
`

/* ── Skeleton (carregamento progressivo) ─────────────────────── */

const skeletonBase = css`
    background: linear-gradient(90deg,
        var(--skel-a, ${SURF2}) 0%,
        var(--skel-b, ${GRAY_LINE}) 50%,
        var(--skel-a, ${SURF2}) 100%);
    background-size: 800px 100%;
    animation: ${shimmer} 1.3s linear infinite;
    border-radius: 8px;
`

export const SkeletonLine = styled.div`
    ${skeletonBase}
    height: ${({ $h }) => $h || '14px'};
    width: ${({ $w }) => $w || '100%'};
    margin: 4px 0;
`

export const SkeletonCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 12px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

/* ── Card da matéria (nível 1) ─────────────────────────────────── */

export const MatterCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 14px;
    overflow: hidden;
    transition: box-shadow .15s ease;
    &:hover { box-shadow: 0 4px 14px rgba(0,0,0,.16); }

    @media (max-width: ${bp.mobile}) {
        border-radius: 12px;
    }
`

export const MatterHeader = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 16px 18px;
    background: ${({ $open }) => ($open ? TEAL_SOFT : 'var(--surface)')};
    color: ${TEXT};
    border: none;
    cursor: pointer;
    text-align: left;
    transition: background .15s ease;
    min-height: 56px;
    &:hover { background: ${TEAL_SOFT}; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: -2px; }

    @media (max-width: ${bp.mobile}) {
        padding: 12px 14px;
        gap: 8px;
        flex-wrap: wrap;
    }
`

export const MatterTitle = styled.span`
    font-weight: 700;
    font-size: 15px;
    color: ${TEAL_TEXT};
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;

    @media (max-width: ${bp.mobile}) {
        font-size: 14px;
        gap: 8px;
    }
`

export const Badge = styled.span`
    background: ${TEAL};
    color: #fff;
    font-size: 11px;
    padding: 3px 8px;
    border-radius: 999px;
    font-weight: 600;
    letter-spacing: 0.2px;
    white-space: nowrap;
`

export const ChevronWrap = styled.span`
    color: ${TEAL_TEXT};
    font-size: 13px;
    transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
    transition: transform .2s ease;
    flex-shrink: 0;
`

export const MatterBody = styled.div`
    animation: ${expand} .25s ease;
    background: ${GRAY_BG};
    border-top: 1px solid ${GRAY_LINE};
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: ${bp.mobile}) {
        padding: 8px;
        gap: 6px;
    }
`

/* ── Card do bimestre (nível 2) ────────────────────────────────── */

export const BimesterCard = styled.div`
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 10px;
    overflow: hidden;
`

export const BimesterHeader = styled.button`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 12px 14px;
    background: ${({ $open }) => ($open ? GRAY_BG : 'var(--surface)')};
    color: ${TEXT};
    border: none;
    cursor: pointer;
    text-align: left;
    transition: background .15s ease;
    min-height: 52px;
    &:hover { background: ${GRAY_BG}; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: -2px; }

    @media (max-width: ${bp.mobile}) {
        padding: 12px;
        flex-wrap: wrap;
        align-items: flex-start;
    }
`

export const BimesterTitle = styled.span`
    font-weight: 600;
    font-size: 13px;
    color: ${TEXT2};
    text-transform: uppercase;
    letter-spacing: 0.4px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    @media (max-width: ${bp.mobile}) {
        font-size: 12px;
        letter-spacing: 0.3px;
    }
`

export const BimesterBody = styled.div`
    animation: ${expand} .2s ease;
    padding: 6px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`

/* ── Item de atividade (nível 3) ───────────────────────────────── */

export const ActivityRow = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 10px;
    align-items: center;
    padding: 12px 14px;
    background: var(--surface);
    border: 1px solid ${GRAY_LINE};
    border-radius: 10px;
    transition: border-color .15s ease;
    &:hover { border-color: ${TEAL_LIGHT}; }

    @media (max-width: ${bp.tablet}) {
        grid-template-columns: 1fr;
        gap: 12px;
    }
    @media (max-width: ${bp.mobile}) {
        padding: 12px;
    }
`

export const ActivityInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`

export const ActivityTitle = styled.span`
    font-weight: 600;
    color: ${TEAL_TEXT};
    font-size: 14px;
    overflow-wrap: anywhere;
`

export const ActivityMeta = styled.span`
    font-size: 12px;
    color: ${GRAY_TEXT};
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    align-items: center;

    @media (max-width: ${bp.mobile}) {
        gap: 6px;
    }
`

export const Tag = styled.span`
    background: ${({ $variant }) =>
        $variant === 'tipo' ? GREEN_SOFT :
            $variant === 'valor' ? AMBER_SOFT :
                $variant === 'media' ? BLUE_SOFT :
                    $variant === 'c' ? RED_SOFT :
                        SURF2};

    /* nome do aluno (default) usa cor de texto forte pra não sumir no dark;
       as variantes de contagem mantêm suas cores de destaque */
    color: ${({ $variant }) =>
        $variant === 'tipo' ? GREEN :
            $variant === 'valor' ? AMBER :
                $variant === 'media' ? BLUE :
                $variant === 'c' ? RED :
                TEXT};

    border: 1px solid ${GRAY_LINE};
    border-radius: 6px;
    padding: 2px 8px;
    font-weight: 600;
    font-size: 11px;
    white-space: nowrap;
`

// Tag do conceito: cor do conceito (texto + fundo suave).
// A verde, B azul, C âmbar, D vermelho — seguindo o tema, sem color-mix.
export const ConceptTag = styled.span`
    color: ${({ grade }) => {
        switch (grade) {
            case 'A': return GREEN;
            case 'B': return BLUE;
            case 'C': return AMBER;
            case 'D': return RED;
            default: return TEXT;
        }
    }};

    background: ${({ grade }) => {
        switch (grade) {
            case 'A': return GREEN_SOFT;
            case 'B': return BLUE_SOFT;
            case 'C': return AMBER_SOFT;
            case 'D': return RED_SOFT;
            default: return SURF2;
        }
    }};

    border-radius: 6px;
    padding: 2px 8px;
    font-weight: bold;
    font-size: 11px;
    white-space: nowrap;

    @media (max-width: 375px) {
        font-size: 11pt;
        padding: 3px;
    }
    @media (min-width: 375px) and (max-width: 768px) {
        font-size: 13pt;
        padding: 5px;
    }
`
export const TagSpan = styled.span`
    background: var(--surface);
    color: ${TEXT};
    border: 1px solid ${GRAY_LINE};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
    border-radius: 6px;
    padding: 20px 8px;
    font-weight: 600;
    font-size: 11px;
    white-space: nowrap;
`

export const ActivityActions = styled.div`
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    justify-content: flex-end;

    @media (max-width: ${bp.tablet}) {
        justify-content: stretch;
        gap: 8px;

        & > button {
            flex: 1;
            min-width: 100px;
        }
    }
    @media (max-width: ${bp.small}) {
        flex-direction: column;
        & > button { width: 100%; }
    }
`

const ActionBase = styled.button`
    border: none;
    padding: 7px 12px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 600;
    transition: filter .12s ease, transform .12s ease;
    min-height: 36px;

    &:hover { filter: brightness(1.08); }
    &:active { transform: translateY(1px); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }
    &:disabled { cursor: not-allowed; }

    @media (max-width: ${bp.tablet}) {
        min-height: 42px;
        font-size: 13px;
        padding: 9px 14px;
    }
`

export const ViewGradesButton = styled(ActionBase)`
    background: ${TEAL};
    color: #fff;

    /* estados controlados via $state pra não usar style inline */
    ${({ $state }) =>
        $state === 'closed' &&
        css`background: #9aa5aa; color: #fff; cursor: not-allowed; opacity: .85;`}
    ${({ $state }) =>
        $state === 'pending' &&
        css`background: ${RED}; color: #fff;`}
    ${({ $state }) =>
        $state === 'done' &&
        css`background: ${GREEN}; color: #fff;`}
`

export const EditButton = styled(ActionBase)`
    background: ${TEAL_SOFT};
    color: ${TEAL_TEXT};
    border: 1px solid ${TEAL_LIGHT};
    &:disabled { opacity: .6; }
`

export const DeleteButton = styled(ActionBase)`
    background: ${RED_SOFT};
    color: ${RED};
    border: 1px solid ${RED};
    &:disabled { opacity: .6; }
`

/* ── Modal de confirmação de delete ────────────────────────────── */

export const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.55);
    backdrop-filter: blur(2px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 16px;
    overscroll-behavior: contain;

    @media (max-width: ${bp.mobile}) {
        padding: 8px;
        align-items: flex-end;
    }
`

export const Modal = styled.div`
    background: var(--surface);
    color: ${TEXT};
    border-radius: 14px;
    padding: 22px;
    width: 100%;
    max-width: 420px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.4);
    text-align: center;
    animation: ${expand} .2s ease;

    @media (max-width: ${bp.mobile}) {
        border-radius: 14px 14px 0 0;
        padding: 20px 16px;
        max-width: 100%;
    }
`

export const ModalTitle = styled.h3`
    margin: 0 0 8px;
    color: ${RED};
    font-size: 17px;
`

export const ModalText = styled.p`
    margin: 0 0 18px;
    color: ${GRAY_TEXT};
    font-size: 14px;
    line-height: 1.5;
`

export const ModalActions = styled.div`
    display: flex;
    gap: 10px;
    justify-content: center;

    @media (max-width: ${bp.small}) {
        flex-direction: column-reverse;
        & > button { width: 100%; }
    }
`

export const ConfirmDelete = styled(ActionBase)`
    background: ${RED};
    color: #fff;
    padding: 10px 18px;
    &:disabled { opacity: .6; }
`

export const Cancel = styled(ActionBase)`
    background: ${SURF2};
    color: ${TEXT};
    border: 1px solid ${GRAY_LINE};
    padding: 10px 18px;
`

/* ── Voltar ────────────────────────────────────────────────────── */

export const ToGoBack = styled.div`
    display: flex;
    gap: 6px;
    justify-content: center;
    padding: 18px 8px 8px;
    cursor: pointer;
    user-select: none;
    color: ${GRAY_TEXT};
    font-size: 14px;
    min-height: 44px;
    align-items: center;
    &:hover { color: ${TEAL_TEXT}; }

    @media (max-width: ${bp.mobile}) {
        padding: 12px 8px;
        font-size: 15px;
    }
`

export const SignMessageButtonText = styled.span``
export const SignMessageButtonTextBold = styled.span`
    font-weight: 700;
    color: ${TEAL_TEXT};
`

/* ── Modal de criação de atividade ─────────────────────────────── */

export const FormCard = styled.div`
    background: var(--surface);
    color: ${TEXT};
    border-radius: 14px;
    padding: 22px;
    width: 100%;
    max-width: 520px;
    box-shadow: 0 12px 40px rgba(0,0,0,0.4);
    max-height: 90vh;
    overflow-y: auto;
    animation: ${expand} .25s ease;

    @media (max-width: ${bp.mobile}) {
        border-radius: 14px 14px 0 0;
        padding: 18px 16px;
        max-height: 95vh;
        max-width: 100%;
    }
`

export const FormHeader = styled.div`
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin-bottom: 18px;
    padding-bottom: 14px;
    border-bottom: 1px solid ${GRAY_LINE};
    gap: 12px;
    flex-wrap: wrap;

    @media (max-width: ${bp.mobile}) {
        margin-bottom: 14px;
        padding-bottom: 12px;
    }
`

export const FormTitle = styled.h3`
    margin: 0;
    color: ${TEAL_TEXT};
    font-size: 18px;
    font-weight: 700;

    @media (max-width: ${bp.mobile}) { font-size: 16px; }
`

export const FormSubtitle = styled.span`
    color: ${TEXT2};
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
`

export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 14px;
`

export const FormLabel = styled.label`
    font-size: 12px;
    font-weight: 600;
    color: ${GRAY_TEXT};
    text-transform: uppercase;
    letter-spacing: 0.3px;
`

const fieldBase = `
    border: 1px solid ${GRAY_LINE};
    background: var(--surface);
    border-radius: 8px;
    padding: 10px 12px;
    font-size: 14px;
    color: ${TEXT};
    outline: none;
    transition: border-color .15s ease, box-shadow .15s ease;
    min-height: 42px;
    width: 100%;
    box-sizing: border-box;
    &:focus {
        border-color: ${TEAL_LIGHT};
        box-shadow: 0 0 0 3px ${RING};
    }
    option { background: var(--surface); color: ${TEXT}; }
    @media (max-width: 540px) {
        font-size: 16px; /* evita zoom no iOS */
        min-height: 44px;
    }
`

export const FormInput = styled.input`
    ${fieldBase}
`

export const FormSelect = styled.select`
    ${fieldBase}
    cursor: pointer;
`

export const FormError = styled.div`
    background: ${RED_SOFT};
    color: ${RED};
    border: 1px solid ${RED};
    padding: 10px 12px;
    border-radius: 8px;
    font-size: 13px;
    margin-bottom: 14px;
`

export const FormActions = styled.div`
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding-top: 14px;
    border-top: 1px solid ${GRAY_LINE};
    margin-top: 6px;

    @media (max-width: ${bp.small}) {
        flex-direction: column-reverse;
        & > button { width: 100%; }
    }
`

export const SaveButton = styled.button`
    background: ${TEAL};
    color: #fff;
    border: none;
    padding: 10px 22px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 700;
    transition: filter .12s ease, transform .12s ease;
    min-height: 42px;
    &:hover { filter: brightness(1.1); }
    &:active { transform: translateY(1px); }
    &:disabled { opacity: .6; pointer-events: none; }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) { min-height: 46px; font-size: 15px; }
`

export const CancelButton = styled.button`
    background: ${SURF2};
    color: ${TEXT};
    border: 1px solid ${GRAY_LINE};
    padding: 10px 22px;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: filter .12s ease;
    min-height: 42px;
    &:hover { filter: brightness(1.12); }
    &:focus-visible { outline: 2px solid ${TEAL_LIGHT}; outline-offset: 2px; }

    @media (max-width: ${bp.mobile}) { min-height: 46px; font-size: 15px; }
`
